import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/caprock/images/down-arrow.svg'
import _imports_1 from '../../assets/caprock/images/up-arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-75641d92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row securities_basic w-100 m-0" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { style: {"font-size":"clamp(12px,2rem,15px)"} }
const _hoisted_4 = {
  key: 0,
  class: "float-right"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " No Of Subscribers ", -1))
const _hoisted_10 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_11 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Investment ", -1))
const _hoisted_13 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_14 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Yield ", -1))
const _hoisted_16 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_17 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Minimum Investment ", -1))
const _hoisted_19 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Currency ", -1))
const _hoisted_23 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_24 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Investment Period ", -1))
const _hoisted_26 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_27 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Coupon ", -1))
const _hoisted_29 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_30 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Subscription ", -1))
const _hoisted_32 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Investment Pub. Date ", -1))
const _hoisted_36 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_37 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Rank ", -1))
const _hoisted_39 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_40 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Type ", -1))
const _hoisted_42 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_43 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Location ", -1))
const _hoisted_45 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Asset Type ", -1))
const _hoisted_49 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_50 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Asset Sector ", -1))
const _hoisted_52 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_53 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Fees ", -1))
const _hoisted_55 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_56 = {
  key: 0,
  class: "row"
}
const _hoisted_57 = { class: "col-md-12 docss general_doc" }
const _hoisted_58 = { class: "table table-bordered table-hover table-sm" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      width: "20%",
      class: "font-white"
    }, "Date"),
    /*#__PURE__*/_createElementVNode("th", {
      width: "50%",
      class: "font-white"
    }, "Investor Name"),
    /*#__PURE__*/_createElementVNode("th", {
      width: "30%",
      class: "font-white"
    }, "Invested Amount")
  ])
], -1))
const _hoisted_60 = { width: "20%" }
const _hoisted_61 = { width: "50%" }
const _hoisted_62 = { width: "30%" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.securities, (security) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-12 mt-3",
        key: security.security_id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("b", _hoisted_3, _toDisplayString(security.security_name) + "   ", 1),
          (typeof (security.investors)!=='undefined')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (security.investor_visible==0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.investor_visible(1,security.security_id)),
                      style: {"cursor":"pointer","height":"13px","width":"13px","margin":"4px 0 0 0"},
                      src: _imports_0
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (security.investor_visible==1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.investor_visible(0,security.security_id)),
                      style: {"cursor":"pointer","height":"13px","width":"13px","margin":"4px 0 0 0"},
                      src: _imports_1
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, _toDisplayString(security.no_of_subscribers), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", _hoisted_13, _toDisplayString(security.inv_name), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", _hoisted_16, _toDisplayString(security.security_yield), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("p", _hoisted_19, _toDisplayString(security.currency_symbol) + " " + _toDisplayString((typeof security.inv_amount!=undefined && _ctx.inv_amount!='' ) ? security.inv_amount :0), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("p", _hoisted_23, _toDisplayString(security.currency_name), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("p", _hoisted_26, _toDisplayString(security.inv_term) + " " + _toDisplayString(typeof (security.inv_term_type)!== 'undefined' && security.inv_term_type==1? 'Month' : 'Year'), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("p", _hoisted_29, _toDisplayString(security.inv_coupon), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("p", _hoisted_32, _toDisplayString(security.inv_subscription) + " " + _toDisplayString(typeof security.inv_subscription_other !='undefied' ? security.inv_subscription_other :'-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("p", _hoisted_36, _toDisplayString(security.investment_publish_date), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("p", _hoisted_39, _toDisplayString(security.inv_rank), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("p", _hoisted_42, _toDisplayString(security.inv_type), 1)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("p", _hoisted_45, _toDisplayString(security.location), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("p", _hoisted_49, _toDisplayString(security.inv_asset_type), 1)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("p", _hoisted_52, _toDisplayString(security.inv_asset_sector), 1)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("p", _hoisted_55, _toDisplayString(security.security_fees), 1)
          ])
        ]),
        (security.investor_visible==1 && typeof (security.investors)!=='undefined')
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("table", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(security.investors, (investor) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: investor.investor_id
                      }, [
                        _createElementVNode("td", _hoisted_60, _toDisplayString(investor.investor_request_date), 1),
                        _createElementVNode("td", _hoisted_61, _toDisplayString(typeof investor.user_type!='undefined' && investor.user_type==1 ? investor.user_first_name+' '+investor.user_last_name : investor.user_company_name), 1),
                        _createElementVNode("td", _hoisted_62, _toDisplayString(typeof investor.investor_inv_amount!='undefined' ? investor.currency_symbol+' '+investor.investor_inv_amount : ''), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}